import React from "react";
import { Tooltip } from "antd";

/**
 * Reusable Custom Tooltip Component
 *
 * Props:
 * - message (string) → Tooltip text
 * - children → Element on which tooltip appears
 * - placement (string) → where tooltip shows (top, right, bottom, left)
 * - color (string) → tooltip background color (optional)
 * - maxWidth (string) → width handling for long text
 */

const CustomTooltip = ({
  message,
  children,
  placement = "top",
  color = "#7509B8",
  maxWidth = "260px",
  autoAdjustOverflow = true,
}) => {
  return (
    <Tooltip
      title={message}
      placement={placement}
      color={color}
      autoAdjustOverflow={autoAdjustOverflow}
      getPopupContainer={() => document.body}   
         zIndex={999999} 
      styles={{
        body: {
          maxWidth: maxWidth,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          lineHeight: "18px",
          fontSize: "13px",
        },
      }}
    >
      <span style={{ cursor: "pointer" }}>{children}</span>
    </Tooltip>
  );
};

export default CustomTooltip;
